import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import app from '../../firebase/config';

export default {
  async mounted() {
    window.messaging ??= getMessaging(app);
    const { messaging } = window;

    // Get firebase token for in app notifications
    if (Notification.permission === 'granted') {
      try {
        const currentToken = await getToken(messaging, { vapidKey: 'BBdaJz9Tt4Vd4XLwkzpGITFFRffBxm567_sFoa6CDcd0_JLoydhau25dH4RNHu3BlyaakAHrU1Nt_58A_dFXXNY' });
        if (currentToken) {
          this.pushEvent('token_received', { token: currentToken });
        }
      } catch (e) {
        if (e.code === 'messaging/permission-blocked') return;
        console.error(e);
      }
    }

    // Show new notifications inside the app
    onMessage(messaging, ({ notification }) => {
      const div = document.createElement('div');
      div.style.position = 'fixed';
      div.style.bottom = '25px';
      div.style.right = '25px';
      div.style.zIndex = 1500;
      div.innerHTML = `<div class="notification is-info"><button class="delete"></button>${notification.body}</div>`;
      document.body.appendChild(div);

      document.querySelectorAll('.notification .delete').forEach(($delete) => {
        const $notification = $delete.parentNode;

        $delete.addEventListener('click', () => {
          $notification.parentNode.removeChild($notification);
        });
      });
    });
  },
};
